import React from 'react'
import ReactDOM from 'react-dom'
import {editors} from 'react-data-grid'

const {EditorBase} = editors

class Editor extends EditorBase {

  getInputNode() {
    let domNode = ReactDOM.findDOMNode(this);
    if (domNode.tagName === 'TEXTAREA') {
      return domNode;
    }

    return domNode.querySelector('textarea:not([type=hidden])');
  }

  render() {
    // <textarea ref={(node) => this.input = node} type="text" onBlur={this.props.onBlur} className="form-control" defaultValue={this.props.value} />
    return (
      <textarea ref={(node) => {
          console.log(node)
          return (this.input = node)
        }} type="text" onBlur={this.props.onBlur}
        className="ta_editor"
        defaultValue={this.props.value}
      />
    )
  }
}

export default Editor



// WEBPACK FOOTER //
// ./src/js/components/Editor.js